// ════════════════════════════════════════════════════════════════════════════
// useEscapeKey — handler de tecla ESC (Modal, Dropdown, etc)
// ════════════════════════════════════════════════════════════════════════════

import { useEffect } from "react";

/**
 * Anexa um listener de keydown para ESC enquanto `enabled === true`.
 * Limpa automaticamente no unmount/disable.
 */
export function useEscapeKey(handler: () => void, enabled = true): void {
  useEffect(() => {
    if (!enabled) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        handler();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [handler, enabled]);
}
